import { Gamepad2, Globe, Heart, ShieldCheck, Smartphone, Zap } from "lucide-react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AboutFirst = () => {

 useEffect(() => {
  let aosInstance;

  import("aos").then((AOS) => {
    aosInstance = AOS.default;
    aosInstance.init({
      duration: 500,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  });

  return () => {
    aosInstance && aosInstance.refreshHard();
  };
}, []);


  return (
    <section
      className="relative bg-gradient-to-b from-[#0b1120] to-[#1a1f35] pb-11 lg:px-8 text-white sm:pt-[130px] pt-[110px]">
      <div className="container mx-auto px-4 ">
        <h1
          className="text-center text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold mb-8"
          data-aos="fade-down"
        >
          About{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
           Game Zone Hub
          </span>
        </h1>   

        {/* 🚀 EXPANDED INTRODUCTION FOR LOW CONTENT QUALITY FIX */}
        <div className="max-w-5xl mx-auto text-center md:mb-20 mb-14" data-aos="fade-up" data-aos-delay="100">
            <p className="text-[16px] md:text-lg text-gray-300 leading-relaxed mb-6">
              Welcome to <strong className="text-blue-400">Game Zone Hub</strong>, the internet's premier, fast-growing destination to <strong>play free online games</strong>. 
              Founded by a dedicated team of passionate gamers, UI/UX designers, and expert web developers, our platform was created with a single, unwavering mission: to make premium digital entertainment accessible to everyone, everywhere, entirely without technological barriers or hidden financial costs.
            </p>
            <p className="text-[16px] md:text-lg text-gray-400 leading-relaxed mb-6">
              In an industry increasingly dominated by pay-to-win mechanics and massive, device-slowing installations, we stand out by meticulously curating an ever-expanding collection of high-quality HTML5 <strong>browser games</strong>. 
              Whether you are an adrenaline junkie looking for high-speed 3D racing simulators, a strategic thinker searching for brain-teasing logic puzzles, or a fan of highly competitive multiplayer action arenas, 
              Game Zone Hub provides a perfectly optimized, inclusive, and engaging environment for players of all ages and skill levels.
            </p>
            <div className="inline-block bg-blue-900/30 border border-blue-500/30 rounded-2xl p-4 mt-2">
                <p className="text-[16px] md:text-lg text-cyan-100 leading-relaxed font-semibold">
                No lengthy downloads. No complicated installations. No premium subscriptions. Just click and play free online instantly.
                </p>
            </div>
        </div>

        <ul
          className="grid text-center lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-8 md:mt-10 sm:mt-8 mt-6"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <li data-aos="zoom-in-up" data-aos-delay="100" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-blue-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-blue-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-500/20 group-hover:rotate-6 transition-all duration-300">
                 <Gamepad2 className="w-10 h-10 text-blue-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Unlimited Free Play</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                Access thousands of premium <strong>free online games</strong> without ever reaching for your wallet. We firmly believe top-tier entertainment should be universally free. You will experience zero microtransactions, no premium paywalls, and absolutely no credit cards are required to enjoy our entire catalog indefinitely.
              </p>
            </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="200" className="h-full">
             <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-yellow-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
               <div className="bg-yellow-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-yellow-500/20 group-hover:scale-110 transition-all duration-300">
                 <Zap className="w-10 h-10 text-yellow-400" />
              </div>
               <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Instant WebGL Engine</h3>
               <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                 Powered by the latest advancements in HTML5 and WebGL cloud technology, our titles load in mere seconds. Say goodbye to exhausting your hard drive's storage space with long, frustrating downloads and mandatory software updates. Just select your favorite title and <strong>play free online</strong> instantly at 60 FPS.
               </p>
             </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="300" className="h-full">
           <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-green-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
             <div className="bg-green-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-green-500/20 group-hover:-rotate-6 transition-all duration-300">
                <ShieldCheck className="w-10 h-10 text-green-400" />
             </div>
             <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Uncompromising Safety</h3>
             <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
               Your digital safety and privacy are our utmost priorities. We rigorously vet, test, and sandbox every single game to guarantee a 100% virus-free and malware-free experience. Our platform is strictly moderated to remain family-friendly and highly secure for children, teens, and adults alike.
             </p>
           </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="400" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6  h-full rounded-3xl shadow-xl border border-white/5 hover:border-purple-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-purple-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-500/20 group-hover:scale-110 transition-all duration-300">
                 <Smartphone className="w-10 h-10 text-purple-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">True Cross-Platform</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                Whether you are relaxing at home on a powerful desktop PC, traveling with an Apple iPad tablet, or commuting with an Android smartphone, our highly responsive interface dynamically adapts to your device. This ensures the ultimate, full-screen <strong>online games</strong> experience on absolutely any screen size.
              </p>
            </div>
          </li>

          <li data-aos="zoom-in-up" data-aos-delay="500" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-pink-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-pink-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-pink-500/20 group-hover:scale-110 transition-all duration-300">
                 <Heart className="w-10 h-10 text-pink-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Curated with Passion</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                We strongly believe in quality over sheer quantity. We do not just dump unplayable or broken files onto our site. Our dedicated editorial team hand-picks the most engaging, visually stunning, and highly-rated titles from indie developers and major studios to ensure you always have a digital masterpiece to play.
              </p>
            </div>
          </li>

          <li data-aos="zoom-in-up" data-aos-delay="600" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6  h-full rounded-3xl shadow-xl border border-white/5 hover:border-cyan-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-cyan-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-cyan-500/20 group-hover:rotate-12 transition-all duration-300">
                 <Globe className="w-10 h-10 text-cyan-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Global Gaming Community</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                Join millions of active, passionate gamers from all around the globe. Compete fiercely in real-time global leaderboards, share your impressive high scores with friends, and become an integral part of the rapidly growing Game Zone Hub family today. The world is your arcade.
              </p>
            </div>
          </li>
          
        </ul>
        
        {/* 🚀 EXPANDED VISION SECTION */}
        <div className="sm:mt-20 mt-12 max-w-5xl mx-auto bg-[#1e293b] sm:p-8  p-6  rounded-3xl border border-white/10 text-center shadow-2xl relative overflow-hidden" data-aos="fade-up">
            <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2 pointer-events-none"></div>
            
            <h2 className="text-3xl md:text-4xl font-extrabold mb-8 text-white relative z-10">Our Vision & Mission</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-400 to-purple-400 mx-auto rounded-full mb-8 relative z-10"></div>
            
            <p className="text-cyan-100 text-lg sm:text-xl font-medium leading-relaxed mb-6 italic relative z-10">
                "Our core vision is to become the world's most accessible, user-friendly, and trusted platform for both casual and competitive browser gaming. We are building a vibrant digital playground where pure fun is just a single click away, all technological barriers are entirely erased, and our dedicated gaming community always comes first."
            </p>
            <p className="text-gray-400 text-base sm:text-lg leading-relaxed relative z-10">
                We are constantly evolving, actively listening to player feedback, and forging strong partnerships with innovative independent game developers to bring you the next generation of HTML5 entertainment. We promise to keep Game Zone Hub free, incredibly fast, and relentlessly fun for everyone.
            </p>
        </div>

        <div
          className="sm:mt-20 mt-10 text-center sm:pb-10"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <h3
            className="sm:text-3xl text-2xl font-extrabold text-white mb-8"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            Ready to Level Up Your Entertainment Today?
          </h3>
          <Link
            to="/games"
            className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-500 hover:to-cyan-400 text-white sm:px-10 px-5 py-3 rounded-full sm:text-lg text-[16px] font-bold shadow-[0_0_25px_rgba(59,130,246,0.6)] hover:shadow-[0_0_40px_rgba(59,130,246,0.8)] transition-all duration-300 transform hover:scale-105"
            data-aos="fade-up"
            data-aos-delay="500"
            aria-label="Play Free Online Games Now"
          >
            <Gamepad2 className="w-6 h-6" /> Play Free Online Games Now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutFirst;